import { Colors } from '../../../../../styles'
import {
  Tooltips,
  ContentTooltips,
  TittleTooltips,
  TooltipsWrapper,
  TooltipItemWrapper,
} from '../../dashboard-jetty.styled'

export const Tooltip = ({ data, id }) => {
  return (
    <TooltipsWrapper>
      <Tooltips
        id={id}
        backgroundColor={Colors.pureWhite}
        textColor={Colors.black}
      >
        <TooltipItemWrapper>
          <TittleTooltips>Vessel Name</TittleTooltips>
          <ContentTooltips>{data?.Vessel_Name}</ContentTooltips>
        </TooltipItemWrapper>
        <TooltipItemWrapper>
          <TittleTooltips>Material Type</TittleTooltips>
          <ContentTooltips>{data?.Material_Type}</ContentTooltips>
        </TooltipItemWrapper>
        <TooltipItemWrapper>
          <TittleTooltips>Material Description</TittleTooltips>
          <ContentTooltips>{data?.Material_Description}</ContentTooltips>
        </TooltipItemWrapper>
        <TooltipItemWrapper>
          <TittleTooltips>Service Number</TittleTooltips>
          <ContentTooltips>{data?.Sr_No}</ContentTooltips>
        </TooltipItemWrapper>
        <TooltipItemWrapper>
          <TittleTooltips>Buyer (recipients)</TittleTooltips>
          <ContentTooltips>{data?.Recipient_Name}</ContentTooltips>
        </TooltipItemWrapper>
      </Tooltips>
    </TooltipsWrapper>
  )
}
